"use strict";
exports.__esModule = true;
exports.ajv = void 0;
var Ajv = require("ajv");
var schema_1 = require("../schema");
var bsnValidator_1 = require("./bsnValidator");
var ibanValidator_1 = require("./ibanValidator");
var passwordValidator_1 = require("./passwordValidator");
exports.ajv = new Ajv({
    allErrors: true,
    nullable: true,
    coerceTypes: true
});
// add formats not specifically defined in spec
exports.ajv.addFormat("password", {
    validate: passwordValidator_1["default"]
});
exports.ajv.addFormat("bsn", {
    validate: bsnValidator_1["default"]
});
exports.ajv.addFormat("iban", {
    validate: ibanValidator_1["default"]
});
exports.ajv.addFormat("nanoid", {
    validate: function (input) { return !!input.match(/^[A-Za-z\-0-9_]+$/); }
});
// Fixing https://trello.com/c/4MTCYPko/95-toparameter-is-not-a-valid-address-please-check-documentation
// Taken from https://emailregex.com/
// Wim Kiebert says: wim.kiebert@gggg is not a valid e-mail address. Default AJV thinks it is.
// Do not allow . after @
exports.ajv.addFormat("email", {
    validate: function (address) {
        return !!address.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    }
});
// add schema using key
exports.ajv.addSchema(schema_1.openapi, "openapi");
